var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-main-container"},[_c('public-header',{attrs:{"show-logo":true}}),_c('div',{staticClass:"dashboard-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }